<template>
  <div class="student-list">
    <el-table
      ref="multipleTable"
      :data="studentData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
      empty-text="暂无数据"
      height="calc(100vh - 280px)"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="studentName"
        label="姓名"
        width="120px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="sex"
        label="性别"
        width="120px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="studentNumber"
        label="学号"
        width="160px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="gradeClass"
        label="年级班级"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="duty"
        label="班级职务"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="politicsStatus"
        label="政治面貌"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="学生状态"
        width="150px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.status == "0" ? "在读" : "毕业" }}
        </template>
      </el-table-column>
      <el-table-column label="家庭地址" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div class="family-location">
            <div class="family-location-Exhibition">
              {{ scope.row.address }}
            </div>
            <div
              class="copy-button"
              @click="copyAddress(`studentId${scope.row.id}`)"
            >
              <i class="iconfont icon-copy"></i>
            </div>
            <div class="family-location-hide">
              <input
                type="text"
                v-model="scope.row.address"
                :id="`studentId${scope.row.id}`"
              />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 素质报告书 -->
            <el-button
              type="success"
              icon="el-icon-notebook-2"
              @click="reportClick(scope.row)"
              v-hasPermi="'sc:semesterdata:query'"
              size="small"
            >
            报告书
            </el-button>
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editClick(scope.row)"
              v-hasPermi="'sc:student:edit'"
              size="small"
            >修改
            </el-button>
            <!-- 删除 -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="deleteClick(scope.row)"
              v-hasPermi="'sc:student:delete'"
              size="small"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改学生信息 -->
    <studentifnoEditstudent
      :dialogFormVisible.sync="editShow"
      :studentInfo="studentInfo"
      :classProps="classProps"
      :classSelect="classSelect"
      :classPlaceholder="classPlaceholder"
      :classInfoArr="classInfoArr"
      :studentTypeList="studentTypeList"
      v-show="editShow"
    />
    <!-- 素质报告书 -->
    <qualityReportDialog
      :dialogFormVisible.sync="qualityReportShow"
      :studentSemesterData="studentSemesterData"
      :titleColspan="titleColspan"
      :contentColspan="contentColspan"
      :jobColspan="jobColspan"
      :rateColspan="rateColspan"
      :rateOptions="rateOptions"
      :semesterOptions="semesterOptions"
      :schoolInfo="schoolInfo"
      :jobData="jobData"
      :classProps="classProps"
      :classSelect="classSelect"
      :classPlaceholder="classPlaceholder"
      :classData="classData"
      :selectStudent="selectStudent"
      @inquireClick="inquireClick"
      @dialogClose="dialogClose"
      v-if="qualityReportShow"
    />
  </div>
</template>

<script>
import studentifnoEditstudent from "../studentifno-editstudent/studentifno-editstudent.vue";
import qualityReportDialog from "../quality-report-dialog/quality-report-dialog.vue";
export default {
  components: {
    studentifnoEditstudent,
    qualityReportDialog,
  },
  data() {
    return {
      title: "修改学生信息",
      studentInfo: {},
      editShow: false,
      qualityReportShow: false,
      classInfoArr: [],
      classPlaceholder: "",
      studentSemesterData: {},
      titleColspan: 8, // 标题
      contentColspan: 3, // 内容
      jobColspan: 4, // 职务
      rateColspan: 6, // 班主任评级
      rateOptions: [],
      schoolInfo: {},
      jobData: {}, // 职务和政治面貌-报告书用
      semesterOptions: [],
      schoolYear: "",
      semester: "",
      selectStudent: {},
      selectClassData: null,
    };
  },
  inject: ["standard", "refresh"],
  props: [
    "studentData",
    "classProps",
    "classSelect",
    "studentTypeList",
    "classData",
  ],
  created() {
    this.getEvaluationGrade();
    this.getSemesterType();
    this.getSchoolDetails();
  },
  mounted() {
    // 初始化赋值默认选中的班级数据
    setTimeout(() => {
      this.selectClassData = this.classData;
      // console.log("this.classData：", this.classData);
    }, 1000);
  },
  watch: {
    classData(newVal, oldVal) {
      this.selectClassData = newVal;
      // console.log("this.classData：", this.classData);
    },
  },
  methods: {
    // 关闭统计表弹窗时重新赋值初始化时的班级数据
    dialogClose(e) {
      this.selectClassData = this.classData;
      this.qualityReportShow = e;
      this.getSchoolDetails();
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        // console.log("查询学校信息==>", res);
        this.schoolInfo = res.data;
        this.semester = res.data.semester;
        this.schoolYear = res.data.schoolYear;
      });
    },
    // 获取考试评定类型选择列表数据
    getEvaluationGrade() {
      this.get(`${this.$url.getDictType}/evaluation_grade`).then((res) => {
        // console.log("评级：", res);
        this.rateOptions = res.data;
      });
    },
    // 获取学期类型选择列表数据
    getSemesterType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
      this.$emit("studentSelect", this.selectList);
    },
    copyAddress(studentId) {
      let copyVal = document.getElementById(studentId);
      copyVal.select();
      try {
        document.execCommand("copy");
        if (copyVal.value == "") {
          this.$message.warning("地址为空！");
        } else {
          this.$message.success("已复制到粘贴板");
        }
      } catch {
        this.$message.error("当前浏览器不支持复制到粘贴板");
      }
    },
    inquireClick(e) {
      this.semester = e.semesterVal;
      this.schoolYear =
        typeof e.schoolYearVal == "string"
          ? e.schoolYearVal
          : "" + e.schoolYearVal.getFullYear();
      // 将班级数据设置为选中的班级
      this.selectClassData = e.classNameVal;
      this.reportClick(this.selectStudent);
    },
    reportClick(item) {
      // console.log("item:", item);
      this.classPlaceholder = `${item.gradeName} / ${item.className}`;
      this.selectStudent = item;
      let data = {
        schoolId: this.user.schoolId,
        gradeId: item.gradeId,
        classId: item.classId,
        studentId: item.id,
        schoolYear: this.schoolYear,
        semester: this.semester,
      };
      this.post(this.$url.selectStudentSemesterData, data).then((res) => {
        // console.log("获取学生数据统计==>", res);
        // 从 examInfo 中提取所有科目
        const allSubjects = res.data.examInfo.flatMap((exam) =>
          exam.scores.map((score) => ({
            courseId: score.courseId,
            courseName: score.courseName,
          }))
        );

        // 使用 Set 去重
        const uniqueSubjects = [
          ...new Set(allSubjects.map((subject) => subject.courseId)),
        ].map((courseId) =>
          allSubjects.find((subject) => subject.courseId === courseId)
        );
        // console.log(uniqueSubjects);
        
        res.data["uniqueSubjects"] = uniqueSubjects;

        // 设置table表格Colspan属性
        // if (uniqueSubjects.length > 2) {
        //   this.titleColspan = uniqueSubjects.length + 1;
        //   this.contentColspan = uniqueSubjects.length - 2;
        //   this.jobColspan = uniqueSubjects.length;
        //   this.rateColspan = uniqueSubjects.length - 1;
        // } else {
        //   this.disciplineColspan = this.titleColspan - uniqueSubjects.length;
        // }
        if (uniqueSubjects.length > 2) {
          this.titleColspan = 7 + 1;
          this.contentColspan = 7 - 2;
          this.jobColspan = 7;
          this.rateColspan = 7 - 1;
        } else {
          this.disciplineColspan = this.titleColspan - uniqueSubjects.length;
        }

        // 将moralismGrade设置为字符串，否则报告书会显示数字
        if (res.data.semesterEvaluate) {
          res.data.semesterEvaluate["moralismGrade"] =
            "" + res.data.semesterEvaluate.moralismGrade;
        }

        this.studentSemesterData = res.data;

        // 存储学生职务和政治面貌，以便报告书修改添加时使用
        // semesterEvaluate存在则使用semesterEvaluate的数据，否则使用studentInfo中的，两者数据可能存在不同
        const { semesterEvaluate } = res.data;
        this.jobData = {
          duty: semesterEvaluate ? semesterEvaluate.classJob : "",
          politicsStatus: semesterEvaluate
            ? semesterEvaluate.politicsStatus
            : "",
        };

        // 报告书显示
        this.qualityReportShow = true;

        console.log("this.studentSemesterData:", this.studentSemesterData);
      });
    },
    // 点击编辑
    editClick(item) {
      this.classInfoArr = [
        {
          gradeId: item.gradeId,
          gradeName: item.gradeName,
        },
        {
          classId: item.classId,
          className: item.className,
        },
      ];
      this.classPlaceholder = `${item.gradeName} / ${item.className}`;
      // console.log(item);
      this.studentInfo = item;
      this.editShow = true;
    },
    // 点击删除
    deleteClick(item) {
      // console.log(item);
      this.$confirm("是否删除该学生信息?", "删除学生", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          let list = [];
          list.push(item.id);
          this.post(this.$url.deleteStudentPC, list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // console.log(err);
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
@import "./studentInfo-studentList.scss";
</style>
